import { Pipe, PipeTransform } from '@angular/core';

import { get } from 'lodash';
import { PColumn } from '../components/quick-table/quick-table';

@Pipe({
  name: 'getPath',
  standalone: true,
})
export class GetPathPipe implements PipeTransform {
  transform(obj: any, column: PColumn): string {
    const value = get(obj, column.field, 'No disponible');
    //
    if (column.type === 'text') {
      return value.length > 80 ? value.substring(0, 80) + '...' : value;
    }
    return value;
  }
}
